import { createGlobalStyle } from 'styled-components';

export const ArabicGlobalStyle = createGlobalStyle`
	* {
		font-family: 'Noto Sans Arabic', sans-serif !important;
		line-height: 160% !important;
		letter-spacing: normal !important;
	}
`;
